import { message } from 'antd';

/**
 * Configure the Ant Design message component to display faster and on the right side
 */
export const configureMessage = () => {
  // Configure the global message component
  message.config({
    top: 50, // Distance from the top of the viewport
    duration: 2, // Display duration in seconds (default is 3, making it faster)
    maxCount: 3, // Maximum number of messages to display at once
    rtl: false, // Right-to-left direction
  });
};

export default message;
